import { TransactionList } from "./TransactionList";
import { TransactionShow } from "./TransactionShow";
import { TransactionEdit } from "./TransactionEdit";

export default {
  list: TransactionList,
  show: TransactionShow,
  edit: TransactionEdit,
};
